import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.orderDetails || initialState;

export const selectOrderDetails = createSelector(
  [selectDomain],
  (state) => state.details
);

export const selectCheckForGRN = createSelector(
  [selectDomain],
  (state) => state.checkForGRN
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectRequestingHardcopy = createSelector(
  [selectDomain],
  (state) => state.requestingHardcopy
);

export const selectRaisingDispute = createSelector(
  [selectDomain],
  (state) => state.raisingDispute
);

export const selectContactSupport = createSelector(
  [selectDomain],
  (state) => state.contactSupport
);
